<template>
  <!-- 充电订单 -->
  <div class="app-container">
    <el-form :inline="true" @keyup.enter.native="toFilter">
      <el-form-item label="资产码">
        <el-input placeholder="请输入资产码" v-model="filter.groupName" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button icon="el-icon-search" type="primary" @click="toFilter">{{ $t("publics.querybtn") }}</el-button>
        <!-- <el-button   icon="el-icon-plus" type="success"
          @click="onAdd" v-permision_tjtf="'add'">{{ $t("publics.add") }}</el-button> -->
      </el-form-item>
    </el-form>

    <el-table header-cell-class-name="table-header-cell" :data="tableData" height="100%" v-loading="loading">
      <el-table-column label="序号" type="index" width="80" align="center"></el-table-column>
      <el-table-column label="资产码" prop="asset_code" width="220" align="center"></el-table-column>
      <el-table-column label="故障数" prop="faultSum" width="80" align="center"></el-table-column>
      <el-table-column label="故障码" prop="faultValue_db" width="120" align="center"></el-table-column>
      <el-table-column label="故障详情" prop="faultValue_desc" align="center"></el-table-column>
      <el-table-column label="告警数" prop="warnSum" width="80" align="center"></el-table-column>
      <el-table-column label="告警码" prop="warnValue_db" width="120" align="center"></el-table-column>
      <el-table-column label="是否回复" prop="resp_flag" width="110" align="center">
        <template slot-scope="{ row }">
          <el-tag type="success" v-if="row.resp_flag == 1">已回复</el-tag>
          <el-tag type="danger" v-else>未回复</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="创建时间" prop="create_time" width="160" align="center"></el-table-column>
      <!-- <el-table-column label="修改时间" prop="modify_time" align="center"></el-table-column> -->

      <el-table-column :label="$t('publics.operation')" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" @click="onDetail(row)" v-permision_tjtf="'detail'">详情</el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="my-pagination">
      <el-pagination background layout="sizes,total,prev,pager,next,jumper" :total="pageParams.total"
        :page-size="pageParams.limit" :page-sizes="[5, 10, 50, 100, 500, 1000]" :current-page="pageParams.page"
        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>

    <el-dialog :visible.sync="detailVisible" title="故障详情" width="800px" :close-on-click-modal="false">
      <el-row type="flex" justify="center">
        <el-col :span="24">
          <el-form label-position="right" label-width="120px" :model="detailForm" ref="detailForm">
            <el-row :gutter="20">
              <!-- 第一列 -->
              <el-col :span="12">
                <el-form-item label="ID" prop="ID">
                  <el-input v-model="detailForm.ID" readonly disabled />
                </el-form-item>

                <el-form-item label="三元编号" prop="triplet_id">
                  <el-input v-model="detailForm.triplet_id" readonly disabled />
                </el-form-item>

                <el-form-item label="资产码" prop="asset_code">
                  <el-input v-model="detailForm.asset_code" readonly disabled />
                </el-form-item>

                <el-form-item label="枪号" prop="gunNo">
                  <el-input v-model="detailForm.gunNo" readonly disabled />
                </el-form-item>

                <el-form-item label="故障数" prop="faultSum">
                  <el-input v-model="detailForm.faultSum" readonly disabled />
                </el-form-item>

                <el-form-item label="告警数" prop="warnSum">
                  <el-input v-model="detailForm.warnSum" readonly disabled />
                </el-form-item>
              </el-col>

              <!-- 第二列 -->
              <el-col :span="12">
                <el-form-item label="是否回复" prop="resp_flag">
                  <el-input :value="respFlagText" readonly disabled />
                </el-form-item>
                <el-form-item label="设备时间" prop="timestamp_id">
                  <el-input v-model="detailForm.timestamp_id" readonly disabled />
                </el-form-item>
                <el-form-item label="创建时间" prop="create_time">
                  <el-input v-model="detailForm.create_time" readonly disabled />
                </el-form-item>

                <el-form-item label="修改时间" prop="modify_time">
                  <el-input v-model="detailForm.modify_time" readonly disabled />
                </el-form-item>
                <el-form-item label="故障" prop="faultValue_db">
                  <el-input v-model="detailForm.faultValue_db" readonly disabled />
                </el-form-item>

                <el-form-item label="告警" prop="warnValue_db">
                  <el-input v-model="detailForm.warnValue_db" readonly disabled />
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
import pageMixin from "@/mixins/pageMixin"
import fileUpload from "@/components/fileUpload/fileUpload.vue"
import { GetDevFaultPageList } from "@/api/dev_data_view"
import { mapGetters } from "vuex"
export default {
  name: "GroupManage",
  mixins: [pageMixin],
  components: { fileUpload },
  data() {
    return {
      detailForm: {},
      detailVisible: false,
      visible: {
        editGroup: false
      },
      tableData: [],
      filter: {
        groupName: ""
      },
      loading: false,
      isUpdate: true,
      gid: "" //街道id
    }
  },
  computed: {
    ...mapGetters(["userInfo"]),
    respFlagText() {
      if (this.detailForm.resp_flag === 1) {
        return "已回复"
      } else if (this.detailForm.resp_flag === 0) {
        return "未回复"
      } else {
        return this.detailForm.resp_flag
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    onDetail(row) {
      this.detailForm = { ...row }
      this.detailVisible = true
    },
    getData() {
      this.loading = true
      GetDevFaultPageList({
        page: this.pageParams.page,
        pagesize: this.pageParams.limit,
        assets_code: this.filter.groupName || null
      })
        .then((res) => {
          this.tableData = res.data
          this.pageParams.total = res.total
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style scoped>
.p-20 {
  padding: 20px;
}
</style>
